import { createSelector } from 'reselect';
import { name } from '../reducers/dashboardTab';
import { createDomainScopedSelector } from './domainSelectorHelper';

const makeSelectDashboardTabContent = (tabKey) => createSelector(createDomainScopedSelector(name), (substate) => substate.byId[tabKey]);

const makeSelectActiveDashboardTabKey = () => createSelector(createDomainScopedSelector(name), (substate) => substate.activeTabId);

const makeSelectActiveDashboardTabContent = () => createSelector(createDomainScopedSelector(name), (substate) => substate.byId[substate.activeTabId]);

export { makeSelectDashboardTabContent, makeSelectActiveDashboardTabKey, makeSelectActiveDashboardTabContent };
